import { useContext } from "react";
import CurrentUserContext from "contexts/CurrentUserContext";
const useCurrentUser = (failWithoutContext = true) => {
  const currentUser = useContext(CurrentUserContext);
  if (!currentUser && failWithoutContext) {
    throw new Error("useCurrentUser hook needs to be used inside CurrentUserContext.Provider");
  }
  return currentUser;
};
export default useCurrentUser;
